import { useState, Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import "./MessageList.css";
import Loader from "../Components/Loader";
import renderMessage from "../Helper/renderMessage";

function MessageListTranscription({ messages = [] }) {
  const [isModalMediaOpen, setIsModalMediaOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedMediaURL, setSelectedMediaURL] = useState("");

  return (
    <div className="message-list">
      {messages?.length ? (
        <div
          className="message-list-content infinite-scroll-target"
          id="messageListInfiniteScrollTarget"
        >
          <InfiniteScroll
            dataLength={messages.length}
            // hasMore={messages.length < total}
            // inverse
            loader={<Loader />}
            scrollableTarget="messageListInfiniteScrollTarget"
            scrollThreshold={0.5}
            style={{ display: "flex", flexDirection: "column" }}
            next={() => {
              setPage(page + 1);
            }}
          >
            {messages?.map((message, index) => {
              return (
                <Fragment key={index}>
                  <div>
                    <div
                      className={`message-bubble-container
                        ${
                          message.speaker === "speaker_1" ? "agent" : "customer"
                        }
                      `}
                    >
                      <div className="message-bubble">
                        <span className="sender-name">
                          {message.speaker === "speaker_1"
                            ? "Speaker 1"
                            : "Speaker 2"}
                        </span>

                        {renderMessage(
                          message.text,
                          null,
                          null,
                          null,
                          setIsModalMediaOpen,
                          setSelectedMediaURL
                        )}

                        <div className="message-info">
                          <span className="message-time">{message.start}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              );
            })}
          </InfiniteScroll>
        </div>
      ) : (
        <p className="empty">No transcription found.</p>
      )}
    </div>
  );
}

export default MessageListTranscription;
